import Svg, {G, Path, type PathProps, type SvgProps} from 'react-native-svg'

import {useTheme} from '#/alf'

const CONTENT_WIDTH = 716.87
const CONTENT_HEIGHT = 129.7

const ratio = CONTENT_HEIGHT / CONTENT_WIDTH

export function LogomarkWithType({
  fill,
  ...rest
}: {fill?: PathProps['fill']} & SvgProps) {
  const t = useTheme()
  const size = parseInt(`${rest.width || 32}`)
  const _fill = fill || t.atoms.text.color

  return (
    <Svg
      fill="none"
      viewBox={`0 0 ${CONTENT_WIDTH} ${CONTENT_HEIGHT}`}
      {...rest}
      width={size}
      height={Number(size) * ratio}>
      <G scale={0.53374}>
        <Path
          fill={_fill}
          d="M148.846 144.562C148.846 159.75 161.158 172.062 176.346 172.062H207.012V185.865H176.346C161.158 185.865 148.846 198.177 148.846 213.365V243.045H136.029V213.365C136.029 198.177 123.717 185.865 108.529 185.865H77.8633V172.062H108.529C123.717 172.062 136.029 159.75 136.029 144.562V113.896H148.846V144.562Z"
        />
        <Path
          fill={_fill}
          d="M170.946 31.8766C160.207 42.616 160.207 60.0281 170.946 70.7675L192.631 92.4516L182.871 102.212L161.186 80.5275C150.447 69.7881 133.035 69.7881 122.296 80.5275L101.309 101.514L92.2456 92.4509L113.232 71.4642C123.972 60.7248 123.972 43.3128 113.232 32.5733L91.5488 10.8899L101.309 1.12988L122.993 22.814C133.732 33.5533 151.144 33.5534 161.884 22.814L183.568 1.12988L192.631 10.1925L170.946 31.8766Z"
        />
        <Path
          fill={_fill}
          d="M79.0525 75.3259C75.1216 89.9962 83.8276 105.076 98.498 109.006L128.119 116.943L124.547 130.275L94.9267 122.338C80.2564 118.407 65.1772 127.113 61.2463 141.784L53.5643 170.453L41.1837 167.136L48.8654 138.467C52.7963 123.797 44.0902 108.718 29.4199 104.787L-0.201172 96.8497L3.37124 83.5173L32.9923 91.4542C47.6626 95.3851 62.7419 86.679 66.6728 72.0088L74.6098 42.3877L86.9895 45.7048L79.0525 75.3259Z"
        />
        <Path
          fill={_fill}
          d="M218.413 71.4229C222.344 86.093 237.423 94.7992 252.094 90.8683L281.715 82.9313L285.287 96.2628L255.666 104.2C240.995 108.131 232.29 123.21 236.22 137.88L243.902 166.55L231.522 169.867L223.841 141.198C219.91 126.528 204.831 117.822 190.16 121.753L160.539 129.69L156.967 116.357L186.588 108.42C201.258 104.49 209.964 89.4103 206.033 74.74L198.096 45.1189L210.476 41.8018L218.413 71.4229Z"
        />
      </G>
      <G x={182} y={0.402344}>
        <Path
          fill={_fill}
          d="M12.9698 100.475C6.05259 100.475 0 94.4225 0 87.5053V-0.401367H17.2931V21.215C17.2931 25.106 20.6076 28.4205 24.4986 28.4205H50.4382C57.3555 28.4205 63.4081 34.4731 63.4081 41.3903V87.5053C63.4081 94.4225 57.3555 100.475 50.4382 100.475H12.9698ZM17.2931 73.0943C17.2931 80.8762 23.9221 87.5053 31.704 87.5053C39.4859 87.5053 46.1149 80.8762 46.1149 73.0943V55.8012C46.1149 48.0193 39.4859 41.3903 31.704 41.3903C23.9221 41.3903 17.2931 48.0193 17.2931 55.8012V73.0943Z"
        />
        <Path
          fill={_fill}
          d="M76.3835 100.475V-0.401367H93.6766V100.475H76.3835Z"
        />
        <Path
          fill={_fill}
          d="M119.65 100.475C112.733 100.475 106.68 94.4225 106.68 87.5053V76.2647C106.68 71.5091 110.283 66.1771 114.75 64.4478L143.86 52.919C149.048 50.9015 147.751 44.2725 142.275 44.2725H107.545V28.4205H152.795C159.712 28.4205 165.765 34.4731 165.765 41.3903V87.5053C165.765 94.4225 159.712 100.475 152.795 100.475H119.65ZM125.559 78.8587C125.559 85.1995 131.035 90.3874 137.375 90.3874C143.428 90.3874 148.616 85.1995 148.616 78.8587C148.616 72.8061 143.428 67.33 137.375 67.33C131.035 67.33 125.559 72.8061 125.559 78.8587Z"
        />
        <Path
          fill={_fill}
          d="M191.738 100.475C184.821 100.475 178.769 94.4225 178.769 87.5053V41.3903C178.769 34.4731 184.821 28.4205 191.738 28.4205H232.665V44.2725H204.708C199.953 44.2725 196.062 48.1634 196.062 52.919V75.9765C196.062 80.7321 199.953 84.6231 204.708 84.6231H232.665V100.475H191.738Z"
        />
        <Path
          fill={_fill}
          d="M245.087 100.475V-0.401367H262.38V47.8752C262.38 52.0544 267.136 54.0719 269.874 50.7574L288.176 28.4205H310.801L288.608 55.8012C286.014 58.9716 285.726 63.1508 288.032 66.6094L311.089 100.475H290.049L270.594 72.0856C267.856 68.0505 262.38 70.2122 262.38 74.8236V100.475H245.087Z"
        />
        <Path
          fill={_fill}
          d="M321.23 100.474V84.6221H354.807C361.436 84.6221 362.301 76.1197 356.393 74.2462L328.579 65.1674C324.112 63.7263 320.365 58.5383 320.365 53.7827V41.3893C320.365 34.4721 326.418 28.4195 333.335 28.4195H378.729V44.2715H345.44C338.811 44.2715 337.802 52.6298 343.711 54.6474L371.38 63.7263C375.847 65.1674 379.594 70.3553 379.594 75.1109V87.5043C379.594 94.4215 373.542 100.474 366.624 100.474H321.23Z"
        />
        <Path
          fill={_fill}
          d="M395.403 100.474V-0.402344H412.696V47.8742C412.696 52.0534 417.452 54.0709 420.19 50.7564L438.492 28.4195H461.117L438.924 55.8003C436.33 58.9707 436.042 63.1498 438.348 66.6084L461.405 100.474H440.365L420.911 72.0846C418.173 68.0495 412.696 70.2112 412.696 74.8227V100.474H395.403Z"
        />
        <Path
          fill={_fill}
          d="M471.61 129.296V113.444H512.537C516.14 113.444 519.022 110.562 519.022 106.959C519.022 103.356 516.14 100.474 512.537 100.474H484.436C477.519 100.474 471.466 94.4215 471.466 87.5043V28.4195H488.759V73.0934C488.759 80.8753 495.388 87.5043 503.17 87.5043C510.952 87.5043 517.581 80.8753 517.581 73.0934V28.4195H534.874V116.326C534.874 123.243 528.821 129.296 521.904 129.296H471.61Z"
        />
      </G>
    </Svg>
  )
}
